export const FeatureImage = ({ src }: { src: string }) => (
  <div className="col-span-6 flex justify-center overflow-hidden rounded-[10px] xl:col-span-7">
    <img alt="" loading="lazy" src={src} className="object-cover" />
  </div>
);
